import { render, staticRenderFns } from "./superBAudit.vue?vue&type=template&id=01024975&"
import script from "./superBAudit.vue?vue&type=script&lang=js&"
export * from "./superBAudit.vue?vue&type=script&lang=js&"
import style0 from "./superBAudit.vue?vue&type=style&index=0&id=01024975&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports